const EARTH_RADIUS_METERS = 6_371_000;

export const DEFAULT_AUTO_CHECKOUT_DISTANCE_METERS = 400;
export const MIN_AUTO_CHECKOUT_DISTANCE_METERS = 50;
export const MAX_AUTO_CHECKOUT_DISTANCE_METERS = 5000;
/** GPS is sampled only while the cleaner app is visible and a session is open. */
export const GPS_POLL_INTERVAL_MS = 600_000;
export const STALE_SESSION_HOURS = 8;

export function haversineDistanceMeters(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_METERS * c;
}

export function clampAutoCheckoutDistanceMeters(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_AUTO_CHECKOUT_DISTANCE_METERS;
  return Math.min(
    MAX_AUTO_CHECKOUT_DISTANCE_METERS,
    Math.max(MIN_AUTO_CHECKOUT_DISTANCE_METERS, Math.round(value)),
  );
}

export function isBeyondAutoCheckoutDistance(
  distanceMeters: number,
  thresholdMeters: number = DEFAULT_AUTO_CHECKOUT_DISTANCE_METERS,
): boolean {
  return distanceMeters > clampAutoCheckoutDistanceMeters(thresholdMeters);
}

export function isStaleWorkSession(
  startedAtIso: string,
  nowMs: number = Date.now(),
  maxHours: number = STALE_SESSION_HOURS,
): boolean {
  const started = new Date(startedAtIso).getTime();
  if (!Number.isFinite(started)) return false;
  return nowMs - started >= maxHours * 60 * 60 * 1000;
}
